var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 17.263v-1.684s1.568-1.478 1.682-2.486c0 0 .818-.565.818-1.578 0-.702-.313-.808-.313-.808s.563-1.069.563-2.089C19.75 6.573 18.724 5 17 5c0 0-.732-1-2-1-2.692 0-4.875 1.622-4.875 4.524 0 1.227.688 2.183.688 2.183s-.313.153-.313.808c0 1.273.818 1.578.818 1.578.114 1.008 1.682 2.486 1.682 2.486v1.684c-.842 2.526-6 .862-6 6.737h16c0-5.895-5.158-4.211-6-6.737z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.618c0 .735-.172 1.441-.358 1.989.069.271.108.573.108.908 0 2.47-2.5 4.934-2.5 4.934.543.237 2.28 1.12 2.99 1.551H30c0-5.25-4.263-3.75-5-6v-1.5c.332-.167 1.122-1.316 1.222-2.214.26-.02.778-.657.778-1.226s-.18-.807-.337-.899c0 0 .337-.752.337-1.661 0-1.821-.492-3.5-2-3.5 0 0-.433-1-2-1-2.223 0-3.588 1.529-3.918 3.533 1.616.866 2.668 2.734 2.668 5.085zM11 16.392c-.543-.58-1.327-1.582-1.612-2.341-.624-.313-1.151-.682-1.388-1.3v-1.008c.19 0 .751-.044.948-.088-.446-.687-.823-2.253-.823-3.131 0-2.233.961-4.07 2.556-5.221C10.2 1.462 9.132 0 6.601 0 5.687 0 5 1 5 1c-5.235 0-2.346 8.355-3.884 9.587 0 0 .942 1.167 3.884 1.167v.998C4.187 14.87 0 14.087 0 18h8.023C8.727 17.574 11 16.392 11 16.392z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUsers);
export default __webpack_public_path__ + "static/media/icon_users.06d7a51bab48f41cb9e361b21608f338.svg";
export { ForwardRef as ReactComponent };